import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Modal,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  Tooltip,
  CircularProgress,
  DialogTitle,
  Stack,
  Slide,
  InputAdornment,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useTranslation } from "react-i18next";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { Margin } from "@mui/icons-material";
import nopdf from "../../../assets/images/nopdf.png";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { TransitionProps } from "@mui/material/transitions";

const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: '95vw', sm: '90vw', md: '80vw', lg: '70vw' }, // Responsive width
  maxWidth: '1100px', // Slightly adjusted max width
  height: { xs: '80vh', md: '85vh' },          // Responsive height
  bgcolor: "background.paper", // Use theme background
  border: 'none', // Remove border, rely on shadow
  borderRadius: '12px', // More rounded corners for modal
  boxShadow: 24,
  p: 0, // Remove padding here, apply to inner boxes
  display: 'flex',
  flexDirection: 'column', // Stack title/close button and iframe
  overflow: 'hidden', // Prevent content spill
};


const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});




type Props = {};

const SplitFileView = (props: Props) => {

  const [openPdfModal, setOpenPdfModal] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState<any>({});
  const [pdfData, setPdfData] = useState<any>(null);
  const [isLoadingTableData, setIsLoadingTableData] = useState(true);

  const [fileOptions, setFileOptions] = useState<any>([]);
  const [selectedFile, setSelectedFile] = useState<any>(null);



  const handleViewPDF = (row: any) => {
    setSelectedPdf(row);
    const formattedPdf = row.pdfBase64.startsWith('data:application/pdf;base64,')
      ? row.pdfBase64
      : `data:application/pdf;base64,${row.pdfBase64}`;

    const byteCharacters = atob(formattedPdf.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    setPdfData(blobUrl);

    setOpenPdfModal(true);
  };

  const handleCloseModal = () => {
    setOpenPdfModal(false);
    setSelectedPdf(null);
    setPdfData(null);
  };


  const ConvertBase64 = (file: Blob) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };



  let navigate = useNavigate();
  const { i18n, t } = useTranslation();

  const [toaster, setToaster] = useState(false);
  const [tableData, setTableData] = useState<any>([]);


  useEffect(() => {
    getFileOptions();
    getDocMng(1);
  }, []);

  const [searchTerm, setSearchTerm] = useState('');

  // Filter table data based on search term
  const filteredData = useMemo(() => {
    if (!searchTerm) return tableData;

    return tableData.filter((row: any) => {
      return (
        row.pgNF?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.pgNU?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.phyIndex?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.comments?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        row.fileName?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
  }, [tableData, searchTerm]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const clearSearch = () => {
    setSearchTerm('');
  };

  const getDocMng = (pdfid: number) => {
    const collectData = {
      dPgid: -1,
      pdFid: pdfid,
      chiPDFid: -1,
      user_Id: -1,
      userId: -1,
    };
    axios
      .post(HOST_URL.HOST_URL2 + `DocFPages/GetDocFPages`, collectData)
      .then((res) => {
        const arr: any = [];
        // console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            id: res.data.data[index]["dPgid"],
            pgNF: res.data.data[index]["pgNF"],
            pgNU: res.data.data[index]["pgNU"],
            phyIndex: res.data.data[index]["phyIndex"],
            comments: res.data.data[index]["comments"],
            phySNo: res.data.data[index]["phySNo"],
            relOfficer: res.data.data[index]["relOfficer"],
            pdFid: res.data.data[index]["pdFid"],
            fileName: res.data.data[index]["fileName"],
            pdfPath: res.data.data[index]["pdfPath"],
            pdfBase64: res.data.data[index]["pdfBase64"],
            isSelected: false,
          });
        }
        setTableData(arr);
        setIsLoadingTableData(false);
      });
  };



  const getFileOptions = async () => {
    try {
      const payload = {
        docMid: -1,
        fileTypId: -1,
        divisionid: -1,
        subsubjId: -1,
        user_Id: -1,
        fileNo: "",
      };
      const response = await axios.post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, payload);

      if (response.data.isSuccess) {
        const data = response.data.data;
        const arr: { label: string; value: number }[] = [];

        for (let index = 0; index < data.length; index++) {
          const doc = data[index];
          const fileEntry = doc.member_DocFiles?.[0];

          if (fileEntry && fileEntry.pdFid) {
            arr.push({
              label: doc.fileNo ? `${doc.fileNo} (${doc.synopsis})` : "_ _",
              value: fileEntry.pdFid,
            });
          }
        }

        setFileOptions(arr);
        setSelectedFile(arr[0]);
      }
    } catch (error) {
      console.error("Error fetching file options:", error);
    }
  };



  const back = useNavigate();


  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          // border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.SplitFileView")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: "blue",
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />

          <ToastApp />
          <Grid item xs={12} container spacing={2}>
            <Grid item xs={12} md={6}>
              <Autocomplete
                disablePortal
                id="pdf-file-select"
                options={fileOptions}
                value={selectedFile}
                onChange={(_, newValue: any) => {
                  setTableData([]);
                  setIsLoadingTableData(true);
                  getDocMng(newValue.value);
                  setSelectedFile(newValue);
                }}
                fullWidth
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("text.SelectPdf")}
                    variant="outlined"
                  />
                )}
                sx={{ mb: { xs: 2, md: 0 } }} // Margin bottom on mobile
              />
            </Grid>
            <Grid item xs={12} md={6}>
              {/* Search TextField */}
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ mb: 2 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      {searchTerm && (
                        <IconButton onClick={clearSearch} size="small">
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} spacing={2}>
              <Table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  border: "1px solid black"
                }}
              >
                <thead
                  style={{
                    backgroundColor: "#2196f3",
                    color: "#f5f5f5",
                  }}
                >
                  <tr>
                    <th
                      style={{
                        borderLeft: "1px solid black",
                        paddingBlock: "10",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                    >
                      {t("text.SrNo")}
                    </th>

                    <th
                      style={{
                        borderLeft: "1px solid black",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                    >
                      {t("text.PageFrom")}
                    </th>
                    <th
                      style={{
                        borderLeft: "1px solid black",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                    >
                      {t("text.PageTo")}
                    </th>
                    <th
                      style={{
                        borderLeft: "1px solid black",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                    >
                      {t("text.PhysicalIndex")}
                    </th>
                    <th
                      style={{
                        borderLeft: "1px solid black",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                    >
                      {t("text.Comments")}
                    </th>
                    <th
                      style={{
                        borderLeft: "1px solid black",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                    >
                      {t("text.ViewFile")}
                    </th>
                  </tr>
                </thead>
                <tbody style={{ border: "1px solid black", position: "relative" }}>
                  {isLoadingTableData ? (
                    <tr>
                      <td colSpan={7} style={{ height: "200px", textAlign: "center" }}>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          alignItems="center"
                          height="100%"
                        >
                          <CircularProgress />
                          <Typography sx={{ mt: 2 }}>{t("text.LoadingData")}...</Typography>
                        </Box>
                      </td>
                    </tr>
                  ) : filteredData.length > 0 ? (
                    filteredData.map((row: any, index: any) => (
                      <tr key={row.id} style={{ border: "1px solid black" }}>
                        <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                          {index + 1}
                        </td>
                        <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                          {row.pgNF}
                        </td>
                        <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                          {row.pgNU}
                        </td>
                        <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                          {row.phyIndex}
                        </td>
                        <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                          {row.comments}
                        </td>
                        <td style={{ borderLeft: "1px solid black", borderTop: "1px solid black", textAlign: "center", padding: "2px" }}>
                          <p
                            onClick={() => handleViewPDF(row)}
                            style={{ cursor: "pointer", color: "blue", textDecoration: "underline", margin: 0 }}
                          >
                            {row.fileName}
                          </p>
                        </td>
                      </tr>

                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} style={{ textAlign: "center", padding: "20px" }}>
                        <Typography color="textSecondary">{t("text.NoDataAvailable")}</Typography>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Grid>
          </Grid>

        </CardContent>
      </div>


      <Dialog
        open={openPdfModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseModal}
        maxWidth="xl" // Use XL for PDFs
        fullWidth
        aria-labelledby="pdf-dialog-title"
        PaperProps={{ sx: { height: '90vh' } }} // Control dialog paper height
      >
        <DialogTitle sx={{ py: 1.5, borderBottom: theme => `1px solid ${theme.palette.divider}` }}> {/* Adjust padding & add border */}
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            {/* Truncate title if too long */}
            <Typography variant="h6" component="div" noWrap sx={{ maxWidth: 'calc(100% - 50px)' }}>
              {selectedPdf?.fileName || 'View PDF'}
            </Typography>
            <IconButton aria-label="close" onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent sx={{ p: 0, overflow: 'hidden', flexGrow: 1 }}> {/* Remove padding, allow content to grow */}
          {selectedPdf ? (
            <iframe
              src={pdfData}
              style={{ width: '100%', height: '100%', border: 'none' }}
              title={selectedPdf?.fileName || 'PDF Document'}
            />
          ) : (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <Typography color="textSecondary">{t("text.NoPDFPreviewAvailable")}</Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SplitFileView;
